const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

export default function formatSize(size) {
    if (size < 1) {
        return '0 Byte';
    }
    const i = parseInt(Math.floor(Math.log(size) / Math.log(1024)));
    return Math.round(size / Math.pow(1024, i), 2) + ' ' + sizes[i];
}